$(document).ready(function(e){
  console.log(
  "%cCustom JS is ready",
  "background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,9,42,1) 35%, rgba(0,212,255,1) 100%); color: #FFF; font-weight: bold; font-size: 50px;"
);


//index 6 slider

 $('.index6-slider').slick({
   dots: true,
   arrows:false,
   infinite: false,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 1,
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });

  
 //featured blog slider

 $('.ftblog-slider').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 1,
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
          dots:true,
          arrows:false
       }
     },
     {
       breakpoint: 600,
       settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows:false
       }
     }
   ]
}); 
 



//for FAQ

$(function () {
    $('.accordion .acc-headng-main').click(function() {
      $(this).parent().toggleClass('active');
      $(this).parent().siblings().removeClass('active');
      $(this).parent().children(".content-box").toggleClass('open').slideToggle();
      $(this).parent().siblings().children(".content-box").removeClass('open').slideUp();
      return false;
    });

    $('.seeAll').click(function(e) {
      e.preventDefault();
      // $(this).siblings('.faqpage.initial-hidden').slideDown();
      $(this).parent().parent().find('.faqpage.initial-hidden').slideDown();
      $(this).parent('.seeall-wrap').remove();
    });
  });

});


// Get Announcement bar dynamic height
function updateAnnouncementHeight() {
  // Get the announcement custom bar element
  const announcementBar = document.querySelector('.utility-bar');
  // Check if the element exists
  if (announcementBar) {
    // Get the height
    const height = announcementBar.offsetHeight;
    // Set the CSS variable
    document.documentElement.style.setProperty('--announcement-height', `${height}px`);
  }
}
document.addEventListener("DOMContentLoaded", function() {
  // Update height when the DOM is fully loaded
  updateAnnouncementHeight();
  // Update height on window resize
  window.addEventListener('resize', updateAnnouncementHeight);
});



document.addEventListener('DOMContentLoaded', function() {
  // Check if there is a hash in the URL
  if (window.location.hash) {
    const id = window.location.hash.substring(1); // Get the ID without the hash (#)
    console.log('Hash detected:', id); // Log the detected hash
    
    // Check if the element with that ID exists on the current page
    if (!document.getElementById(id)) {
      console.log('Element with ID not found on this page:', id); // Log if element is not found
      // Redirect to the correct page where this ID exists
      handleRedirect(id);
    } else {
      console.log('Element with ID found on this page:', id); // Log if element exists on the page
    }
  }
});

function handleRedirect(id) {
  // Define a mapping of IDs to the pages where they exist
  const idPageMapping = {
    'sec8': 'https://ais-collective.myshopify.com/', // Example mapping for #sec8
    // Add more mappings if needed
  };

  // If the ID is in the mapping, redirect to the correct page
  if (idPageMapping[id]) {
    console.log('Redirecting to:', idPageMapping[id]); // Log the redirection
    window.location.assign(idPageMapping[id] + '#' + id); // Redirect using assign
  } else {
    console.error('No mapping found for ID:', id); // Log an error if no mapping is found
  }
}













